import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—");

export default function AdminAudit({ token }) {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/admin/audit`, { headers: { "X-Admin-Token": token } })
      .then((r) => r.json())
      .then((d) => setLogs(d.logs || []))
      .catch(() => setLogs([]));
  }, [token]);

  if (!logs) return <p className="mt-10 font-mono text-[11px] tracking-[0.2em] text-[#6e6e6a]">LOADING…</p>;

  return (
    <div className="mt-2" data-testid="admin-audit">
      <p className="font-mono text-[10px] tracking-[0.3em] text-[#6e6e6a]">
        AUDIT LOG — EVERY ADMIN ACTION (LATEST 200)
      </p>
      <div className="mt-4 border border-[#2e2e2a]" data-testid="admin-audit-list">
        {logs.length === 0 && (
          <p className="px-4 py-3 font-mono text-[11px] text-[#6e6e6a]">No actions recorded yet</p>
        )}
        {logs.map((l, i) => (
          <div key={i} className="flex flex-wrap items-baseline gap-x-4 gap-y-1 px-4 py-3 border-b border-[#2e2e2a] last:border-0 font-mono text-[11px] tracking-[0.05em]">
            <span className="text-[#6e6e6a] whitespace-nowrap">{fmt(l.at)}</span>
            <span className="uppercase tracking-[0.15em]">{l.action?.replace(/_/g, " ")}</span>
            {l.detail && <span className="text-[#a3a39f] break-all">{l.detail}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
